import React from "react";
import Sidebar from "./sidebar/Sidebar";
import SidebarChat from "./sidebar/SidebarChat";
import "./Imessage.css";
import Chat from "./chat/Chat";

function Imessage() {
  return (
    <div className="iMessage">
      <Sidebar />
      <Chat />
    </div>
  );
}

export default Imessage;
